/* istanbul ignore next */
export var noop = function noop() {};